// de_pms_live_board.ts
// Tłumaczenia dla PMS.LiveBoard.Dashboard.tsx

export const dePmsLiveBoard = {

  title:         "Live Board",
  managerView:   "Manager-Dashboard",
  newReservation:"Neue Reservierung",
  today:         "Heute",

  // ── Kafelki główne ───────────────────────────────────────────────────────
  tiles: {
    occupancySold: "Auslastung (heute Nacht verkauft)",
    inHouseNow: "Gäste im Haus (aktuell)",
    readyToSell: "Verkaufsbereit",
    soldTonight: "Heute Nacht verkauft: {{occupied}} / {{sellable}} verkaufbare Zimmer",
    notAvailable: "Nicht verfügbar",
    ofTotal: "{{percent}}% vom Gesamtbestand",
    needsActionWithRoutine: "Handlungsbedarf · {{count}} Routinehinweise",
    inHouseNowHint: "Aktuell im Haus, einschließlich der heutigen Abreisen",
    occupancy:   "Auslastung",
    arrivals:    "Anreisen",
    departures:  "Abreisen",
    inHouse:     "Im Haus",
    readyRooms:  "Bezugsfertige Zimmer",
    openIssues:  "Offene Probleme",
  },

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    housekeeping: "Housekeeping",
    frontDesk:    "Rezeption",
    billing:      "Abrechnung",
  },

  // ── Przyciski operacji ───────────────────────────────────────────────────
  actions: {
    checkIn:        "Einchecken",
    checkInNow:     "Jetzt einchecken",
    checkOut:       "Auschecken",
    confirmCheckIn: "Check-in bestätigen",
    confirmCheckOut:"Check-out bestätigen",
    confirmMove:    "Zimmerwechsel bestätigen",
    earlyCheckIn:   "Früher Check-in",
    lateCheckOut:   "Später Check-out",
    roomMove:       "Zimmerwechsel",
    walkIn:         "Walk-in",
    approve:        "Genehmigen",
    addNote:        "Notiz hinzufügen",
    saveNote:       "Notiz speichern",
  },

  // ── Notatka ──────────────────────────────────────────────────────────────
  noteQuestion: "Was sollte das Team wissen?",

  // ── Statusy i wyniki akcji ───────────────────────────────────────────────
  messages: {
    checkInSuccessful:       "Check-in erfolgreich abgeschlossen",
    checkInFailed:           "Check-in fehlgeschlagen",
    checkOutSuccessful:      "Check-out erfolgreich abgeschlossen",
    checkOutFailed:          "Check-out fehlgeschlagen",
    checkInNotPossible:      "Check-in vor dem Anreisedatum nicht möglich",
    lateCheckoutFailed:      "Später Check-out fehlgeschlagen",
    lateCheckoutUntil:       "Später Check-out bis ",
    roomMoveCompleted:       "Zimmerwechsel abgeschlossen",
    roomMoveFailed:          "Zimmerwechsel fehlgeschlagen",
    roomMovePrefix:          "Wechsel: ",
    noteAdded:               "Notiz hinzugefügt",
    failedToAddNote:         "Notiz konnte nicht hinzugefügt werden",
    alertDismissed:          "Alarm verworfen",
    approved:                "Genehmigt",
    approvedFromLiveBoard:   "Vom Live Board genehmigt",
    paymentPosted:           "Zahlung gebucht",
    chargePosted:            "Belastung gebucht",
    housekeepingTaskCreated: "Housekeeping-Aufgabe erstellt",
    incidentResolved:        "Vorfall gelöst",
    reservationCreated:      "Reservierung erstellt",
    walkInCheckedIn:         "Walk-in eingecheckt: ",
    walkInFailed:            "Walk-in fehlgeschlagen",
    walkInReservationCreated:"Walk-in-Reservierung erstellt",
    roomStatusUpdated:       "Zimmerstatus aktualisiert",
    failedToUpdateRoom:      "Zimmer konnte nicht aktualisiert werden",
    failedToUpdateRoomStatus:"Zimmerstatus konnte nicht aktualisiert werden",
    failedToUpdateIncident:  "Vorfall konnte nicht aktualisiert werden",
    failedToAssign:          "Zuweisung fehlgeschlagen",
    noPropertySelected:      "Kein Hotel ausgewählt",
    noPendingArrivals:       "Keine ausstehenden Anreisen",
    noPendingDepartures:     "Keine ausstehenden Abreisen",
    needsAction:             "Erfordert Aktion",
  },

  // ── Etykiety tabelki/kart ─────────────────────────────────────────────────
  labels: {
    floor:    "Etage ",
    room:     "Zimmer ",
    guest:    "Gast",
    guestsNow:"Gäste jetzt",
    fullName: "Vollständiger Name",
    standard: "Standard",
    nights:   "Nächte",
  },

} as const;

export default dePmsLiveBoard;
